export const ERROR_FIELD_TEXT = 'Заполните поле';

export const EMPTY_ADDRESS_TEXT = 'Адрес не найден или его не существует';

export const BASE_ADDRESS_ERROR_TEXT = 'Адрес должен содержать';

export const INCOMPLETE_ADDRESS_TEXT = 'Выберите адрес из списка с точностью до дома';
